import {useTransition} from '@yandex-delivery/blocks'
import {type ServerError, useBaseErrorCatcher} from '@yandex-delivery/core/utils/network'
import {useCallback, useState} from 'react'
import {useLocation} from 'react-router-dom'
import {type UserFeedback, fetchSendFeedback} from 'src/api'

import {useSharedRouteInfo} from '../../hooks'
import type {RouterParams} from '../../types'
import {toUserFeedback} from './toUserFeedback'

const FEEDBACK_KEY = 'route/feedback'

export const useSendFeedback = () => {
  const location = useLocation<RouterParams>()
  const sharingKey = location.hash.substring(1)
  const info = useSharedRouteInfo()
  const [feedback, setFeedback] = useState<UserFeedback>(toUserFeedback(info) || {})
  const errorCatcher = useBaseErrorCatcher()

  const [, startTransition] = useTransition<unknown, ServerError>(undefined, {
    key: FEEDBACK_KEY,
  })

  const sendFeedbackHandler = useCallback(
    (update: UserFeedback) => {
      const updatedFeedback = {...feedback, ...update}

      // fetchSendFeedback не возвращает ни какого значения, мы оптимистично обновляем значение с updatedFeedback
      setFeedback(updatedFeedback)
      startTransition(() => fetchSendFeedback(updatedFeedback, sharingKey), {
        onError: () => {
          // При возникновении ошибки, откатываем оптимистичный апдейт фидбэка
          setFeedback(feedback)
          errorCatcher()
        },
      })
    },
    [feedback, sharingKey, errorCatcher, startTransition],
  )

  return [feedback, sendFeedbackHandler] as const
}
